module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ljungby-d19d524c11927131c6d9eabd6af90e06.png";